module.exports = __webpack_public_path__ + "assets/img/role-active-3.87eff644.png";